<template>
  <div class="mt-auto">
    <div v-if="pltService" class="d-md-flex d-none justify-content-center">
      <div class="brand-section-body-item">
        <div class="brand-section-body-item_logo">
          <img
            :src="platformLogos[pltService]"
            :alt="`${pltService} logo`"
            style="width: 55px; height: 55px"
          />
        </div>
        <div class="brand-section-body-item_intro">
          <span class="font-weight-bold" style="font-size: 1.1em;">
            {{ $t(`${pltService}_name`) }}
          </span>
          {{ $t(`${pltService}_slogan`) }}
        </div>
      </div>
    </div>
    <div
      :class="[
        'mt-2 mt-md-auto mx-auto w-100 text-right rtl',
        { 'text-right rtl': $i18n.locale !== 'en' },
      ]"
      style="max-width: 500px"
    >
      <div class="mx-auto w-100 border p-3 p-md-4" style="max-width: 430px">
        <div class="d-flex justify-content-center align-items-center">
          <div
            v-if="pltService && platformLogos[pltService]"
            class="brand-section-body-item_logo d-md-none ml-3"
            style="padding: 5px"
          >
            <img :src="platformLogos[pltService]" :alt="`${pltService} logo`" />
          </div>
          <h1
            class="mb-4 text-center"
            style="color: #555; background-color: #fff"
          >
            <span class="form-header" style="font-size: 55%">
              <span>
                {{ $t("login") }}
              </span>
              <span
                v-if="pltService && platformLogos[pltService]"
                class="d-md-none"
                style="font-weight: normal"
              >
                به {{ $t(`${pltService}_name`) }}
              </span>
            </span>
          </h1>
        </div>
        <form
          class="d-flex justify-content-center flex-column w-100"
          method="POST"
          :action="urls.login"
          ref="form"
        >
          <div
            v-if="autoSocialLogin"
            class="alert alert-success rounded-0"
            style="margin-bottom: 2rem"
          >
            <i class="fa fa-info mx-1" style="vertical-align: middle"></i>
            <span v-if="$i18n.locale === 'fa'">
              یک حساب کاربری‌ با این ایمیل از قبل موجود است. برای اتصال حساب
              گوگل‌تان به این حساب، گذرواژه‌تان را وارد کنید
            </span>
            <span v-else>
              This email address is already registered. Please enter your
              password to connect to the associated account.
            </span>
          </div>
          <template v-else>
            <a
              :href="urls.googleLogin"
              class="google_btn mb-1"
              data-gtm-name="login_google"
            >
              <div class="label">{{ $t("google_login") }}</div>
              <div class="icon-container">
                <span class="icon"></span>
              </div>
            </a>
            <div class="divider mb-1">
              <div class="text text-center">{{ $t("or") }}</div>
            </div>
          </template>
          <field-input
            v-model="emailOrMobile"
            ref="email_or_mobile"
            id="login_input"
            type="text"
            name="login"
            class="mb-4"
            :label="
              ![
                'yektanet-rubika-adv',
                'yektanet-sheypoor-adv',
                'yektanet-technolife-adv',
                'yektanet-retail-basalam-adv',
              ].includes(getParam('account_custom_type'))
                ? $t('email_or_mobile')
                : $t('mobile_number')
            "
            :server-error="serverError.login"
            number
            style="margin-bottom: 7px"
            :rules="[
              vRules.required(
                $t('validation_message.email_or_mobile_is_required')
              ),
              vRules.email_or_phone(),
            ]"
            data-gtm-name="login_email_phone"
          />
          <field-input
            v-model="password"
            ref="password"
            id="password_input"
            type="password"
            class="mb-4"
            name="password"
            :label="$t('password')"
            input-class="ltr"
            :server-error="serverError.password"
            style="margin-bottom: 7px"
            :rules="[
              vRules.required($t('validation_message.password_is_required')),
            ]"
            data-gtm-name="password"
          />

          <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken" />
          <input
            v-if="redirectFieldValue"
            type="hidden"
            :name="redirectFieldName"
            :value="redirectFieldValue"
          />

          <div
            v-if="serverError.nonFieldErrors"
            class="mt-0 error-text text-center mb-4"
          >
            {{ serverError.nonFieldErrors }}
          </div>
          <button
            type="submit"
            class="auth-btn btn btn-primary font-5"
            style="margin-bottom: 27px"
            :disabled="isLoading"
          >
            {{ $t("login") }}
          </button>

          <div class="d-flex justify-content-between">
            <a
              :href="urls.beginPasswordReset"
              class="link"
              data-gtm-name="login_password_recovery"
            >
              {{ $t("reset_password") }}
            </a>
            <a :href="signupUrl" class="link" data-gtm-name="login_register">
              {{ $t("signup") }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getParam } from "~/utils";

import FieldInput from "~/components/FieldInput.vue";

export default {
  components: { FieldInput },
  data: () => ({
    pltService: "",
    isLoading: false,
    ...serverData,
    platformLogos,
  }),
  computed: {
    signupUrl() {
      return this.urls.signup + window.location.search;
    },
  },
  methods: {
    getParam,
  },
  mounted() {
    this.pltService = getParam("plt");

    if (this.autoSocialLogin) {
      this.$refs.password.focus();
    } else {
      this.$refs.email_or_mobile.focus();
    }
    this.$refs.form.addEventListener("submit", (e) => {
      this.isLoading = true;
      const email_or_mobile_validation = this.$refs.email_or_mobile.validate();
      const password_validation = this.$refs.password.validate();
      if (!email_or_mobile_validation || !password_validation) {
        e.preventDefault();
        this.isLoading = false;
      } else {
        if (/^9\d{9}$/.test(this.emailOrMobile)) {
          this.emailOrMobile = "0" + this.emailOrMobile;
        } else if (/^\+989\d{9}$/.test(this.emailOrMobile)) {
          this.emailOrMobile = this.emailOrMobile.replace("+98", "0");
        } else if (
          /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(
            this.emailOrMobile
          )
        ) {
          this.emailOrMobile = this.emailOrMobile.toLowerCase();
        }
      }
    });
  },
};
</script>

<style scoped>
/*dirty trick to handle focusing fields when chrome autofill them */
#password_input:-webkit-autofill {
  animation: onAutoFillStart;
}
#login_input:-webkit-autofill {
  animation: onAutoFillStart;
}
@keyframes onAutoFillStart {
  from {
    color: #495057;
  }
  to {
    color: #495058;
  }
}
</style>
